import { RootState } from 'src/reducers/RootReducer';
import { Store } from 'redux';
import { store } from 'src/store';
import Token from 'src/value-objects/Token';

export default class AuthenticationService {
  static instance: AuthenticationService;

  private store: Store<RootState> = store;

  constructor() {
    if (AuthenticationService.instance) {
      return AuthenticationService.instance;
    }

    AuthenticationService.instance = this;
  }

  public getToken(): Token | null {
    return this.store.getState() &&
      this.store.getState().authentication &&
      this.store.getState().authentication.token || null;
  }
}



// WEBPACK FOOTER //
// ./src/services/authentication/Authentication.tsx